import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$futureOrderingLimitPickup',
  initialState,
  reducers: {
    setFutureOrderingLimitPickup(state, action: PayloadAction<number | null>) {
      return Number(action.payload ? action.payload : 0);
    },
  },
});

export const { setFutureOrderingLimitPickup } = slice.actions;
export default slice.reducer;
